(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-portable-kids-micrscope",
      exitUrl: "/pages/7-reasons-why-portable-kids-microscope",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "Discover How This Tiny Microscope Sparks Big Curiosity",
      trustLine: "3,500+ happy families on 90-day guarantee",
      fixedKit: {
        name: "Your Summer Splash Setup Is Unlocked",
        tagline:
          "Best for supervised outdoor splash play on flat grass or a soft outdoor mat.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "You save \xA320 today",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Matching age-friendly discovery style",
          "Checking shared-use needs",
          "Finding the best value option",
          "Adding free learning extras",
        ],
        reviews: [
          {
            text: "My grandkids absolutely love these! No more balloon mess on the lawn.",
            author: "Sandra M.",
            status: "verified buyer \u2714",
          },
          {
            text: "Best purchase this summer. My kids fight over who gets to refill them!",
            author: "Jennifer R.",
            status: "verified buyer \u2714",
          },
          {
            text: "Used these at my grandson's birthday, 15 kids going wild for 3 hours. Zero cleanup!",
            author: "Robert K.",
            status: "verified buyer \u2714",
          },
        ],
      },
      loadingItems: [
          "Matching age-friendly discovery style",
          "Checking shared-use needs",
          "Finding the best value option",
          "Adding free learning extras",
      ],
      resultOffer: {
        headline: "Your Recommended Microscope Kit",
        subheadline:
          "Based on your answers, this kit gives your child a simple, hands-on way to explore the tiny world around them.",
        options: [
          {
            qty: "1 Microscope",
            badge: "Starter Kit",
            price: "\xA329.99",
            comparePrice: "\xA349.99",
            variantId: "REPLACE_WITH_VARIANT_ID_1",
            featured: false,
          },
          {
            qty: "2 Microscopes",
            badge: "MOST POPULAR",
            price: "\xA349.99",
            comparePrice: "\xA399.98",
            variantId: "REPLACE_WITH_VARIANT_ID_2",
            featured: true,
          },
          {
            qty: "3 Microscopes",
            badge: "BEST DEAL",
            price: "\xA364.99",
            comparePrice: "\xA3149.97",
            variantId: "REPLACE_WITH_VARIANT_ID_3",
            featured: false,
          },
        ],
        includes: [
          "1x Digital Microscope for kids",
          "1x Lanyard Strap",
          "1x Microfibre Cloth",
          "10x Prepared Slides (free gift)",
          "1x Exploration Booklet (free gift)",
          "1x Microscope Carry Case (free gift)",
          "1x USB charging cable",
          "1x User manual",
          "90-day money-back guarantee",
        ],
        cta: "Claim My Microscope Kit",
        trustLine: "Covered by a 90-day money-back guarantee.",
      },
      steps: [
        {
          id: "who",
          eyebrow: "Question 1 of 5",
          question: "What does your child love exploring most?",
          subtext: "",
          options: [
            {
              value: "Nature finds like leaves, rocks, and bugs",
              icon: "\uD83C\uDF3F", // 🌿 herb
              label: "Nature finds like leaves, rocks, and bugs",
              desc: "Nature finds like leaves, rocks, and bugs",
            },
            {
              value: "Tiny details in everyday objects",
              icon: "\uD83D\uDD0D", // 🔍 magnifying glass
              label: "Tiny details in everyday objects",
              desc: "Tiny details in everyday objects",
            },
            {
              value: "Science experiments and discovery kits",
              icon: "\uD83D\uDD2C", // 🔬 microscope
              label: "Science experiments and discovery kits",
              desc: "Science experiments and discovery kits",
            },
            {
              value: "They are curious about everything",
              icon: "\uD83E\uDD14", // 🤔 thinking face
              label: "They are curious about everything",
              desc: "They are curious about everything",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Question 2 of 5",
          question: "Where will they use it most?",
          subtext: "",
          options: [
            {
              value: "At home",
              icon: "\uD83C\uDFE0", // 🏠 house
              label: "At home",
              desc: "At home",
            },
            {
              value: "In the backyard",
              icon: "\uD83C\uDF33", // 🌳 deciduous tree
              label: "In the backyard",
              desc: "In the backyard",
            },
            {
              value: "On walks or trips",
              icon: "\uD83D\uDEB6", // 🚶 person walking
              label: "On walks or trips",
              desc: "On walks or trips",
            },
            {
              value: "A mix of everywhere",
              icon: "\uD83C\uDF0D", // 🌍 globe
              label: "A mix of everywhere",
              desc: "A mix of everywhere",
            },
           
          ],
        },
       {
        id: "surface",
        eyebrow: "Question 3 of 5",
        question: "Who will be using the microscope?",
        subtext: "",
        options: [
           {
            value: "One child",
            icon: "\uD83D\uDC66", // 👦 boy
            label: "One child",
            desc: "One child",
          },
          {
            value: "Two children or siblings",
            icon: "\uD83D\uDC6B", // 👫 two people
            label: "Two children or siblings",
            desc: "Two children or siblings",
          },
          {
            value: "Multiple kids / gifts",
            icon: "\uD83D\uDC6A", // 👪 family
            label: "Multiple kids / gifts",
            desc: "Multiple kids / gifts",
          },
          {
            value: "Not sure yet",
            icon: "\uD83E\uDD14", // 🤔 thinking face
            label: "Not sure yet",
            desc: "Not sure yet",
          },
        ],
        },
        {
          id: "hose",
          eyebrow: "Question 4 of 5",
          question: " What matters most to you?",
          subtext:"",
          options: [
           {
            value: "Keeping them engaged without screens",
            icon: "\uD83D\uDCF5", // 📵 no phones
            label: "Keeping them engaged without screens",
            desc: "Keeping them engaged without screens",
          },
          {
            value: "Making science feel fun",
            icon: "\uD83D\uDD2C", // 🔬 microscope
            label: "Making science feel fun",
            desc: "Making science feel fun",
          },
          {
            value: "Giving them a gift they can use again and again",
            icon: "\uD83C\uDF81", // 🎁 wrapped gift
            label: "Giving them a gift they can use again and again",
            desc: "Giving them a gift they can use again and again",
          },
          {
            value: "Finding the best value",
            icon: "\uD83D\uDCB0", // 💰 money bag
            label: "Finding the best value",
            desc: "Finding the best value",
          },
          
          ],
        },
        {
          id: "priority",
          eyebrow: "Question 5 of 5",
          question: "Which option sounds closest?",
          subtext: "",
          options: [
            {
              value: "1 microscope for one child",
              icon: "\uD83D\uDD2C", // 🔬 microscope
              label: "1 microscope for one child",
              desc: "1 microscope for one child",
            },
            {
              value: "2 microscopes for siblings or shared play",
              icon: "\uD83D\uDC6B", // 👫 two people
              label: "2 microscopes for siblings or shared play",
              desc: "2 microscopes for siblings or shared play",
            },
            {
              value: "3 microscopes for best value or multiple gifts",
              icon: "\uD83C\uDF81", // 🎁 wrapped gift
              label: "3 microscopes for best value or multiple gifts",
              desc: "3 microscopes for best value or multiple gifts",
            },
            {
              value: "Not sure, show me the best recommendation",
              icon: "\u2728", // ✨ sparkles
              label: "Not sure, show me the best recommendation",
              desc: "Not sure, show me the best recommendation",
            },
            
          ],
        },
        {
          id: "alternative",
          eyebrow: "Question 6 of 6",
          question: "Tiny Details Can Spark Big Curiosity",
        subtext: "When kids can see the hidden textures in leaves, fabric, paper, and prepared slides, science becomes something they can touch, test, and understand.",
        infoOnly: true,
        options: [],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Takes just 1 minute</div><h1 class="quiz-intro-headline">What Kind Of Little Explorer Do You Have?</h1><p class="quiz-intro-sub">Take the quick quiz to find the best microscope option for your child.</p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> No more picking up balloon pieces</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Refills in 5 seconds by themselves</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> 3,500+ five-star reviews from families</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Start the quiz<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your set is being assembled</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = step.infoOnly ? true : !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Back</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p>' +
        (step.infoOnly
          ? ''
          : '<div class="quiz-options">' +
            step.options
              .map(function (o) {
                return optionCard(o, step.id);
              })
              .join("") +
            '</div>') +
        '<div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "Next" : (step.infoOnly ? "Continue" : "Next")) +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your recommended set is being assembled</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Building Your Explorer Kit\u2026</h2><p class="loading-sub" id="loading-sub">Personalized based on your answers</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub"></p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% OFF</span><span class="kit-ready-btn-text">See my recommendation</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Retake quiz</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200, 5600];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn &&
          (ctaBtn.setAttribute("href", "#"),
          ctaBtn.addEventListener("click", function (e) {
            e.preventDefault();
            state.screen = "result";
            renderResult();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }));
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your set is ready!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
  // Maps the user's answers to a recommended option index, based on
  // Q2 (count = where it's used) and Q3 (surface = who's using it):
  // 0 = 1 Microscope, 1 = 2 Microscopes (MOST POPULAR), 2 = 3 Microscopes (BEST DEAL)
  function pickRecommended() {
    var a = state.answers;
    var count = (a.count || "").toLowerCase(); // Q2: where will they use it
    var surface = (a.surface || "").toLowerCase(); // Q3: who will be using it

    // Q3 is the primary signal.
    if (surface.indexOf("one child") === 0) return 0; // one child -> 1
    if (
      surface.indexOf("two children") === 0 ||
      surface.indexOf("siblings") !== -1
    )
      return 1; // siblings / shared play -> 2
    if (
      surface.indexOf("multiple kids") === 0 ||
      surface.indexOf("gift") !== -1
    )
      return 2; // multiple kids / gifting -> 3

    // Q3 = "Not sure yet" -> lean on Q2 (where they'll use it).
    if (count.indexOf("at home") === 0) return 0; // simple home use -> 1
    if (count.indexOf("backyard") !== -1) return 1; // backyard play -> 2

    // Default when unsure -> 2 Microscopes (MOST POPULAR).
    return 1;
  }

  function renderResult() {
    var offer = CONFIG.resultOffer,
      total = CONFIG.steps.length,
      recIndex = pickRecommended(),
      pBar = el("quiz-progress-wrap");
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Your set is ready!</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');

    var optionsHtml = offer.options
      .map(function (o, i) {
        var isRec = i === recIndex;
        return (
          '<button class="result-option' +
          (isRec ? " recommended selected" : "") +
          '" data-variant="' +
          (o.variantId || "") +
          '" data-index="' +
          i +
          '" type="button" aria-pressed="' +
          (isRec ? "true" : "false") +
          '" style="position:relative;display:flex;flex-direction:column;align-items:flex-start;gap:6px;width:100%;padding:16px 18px;margin:0 0 12px;border:2px solid ' +
          (isRec ? "#38b6ff" : "#e2e2e2") +
          ";border-radius:12px;background:#fff;cursor:pointer;text-align:left;box-sizing:border-box;" +
          (isRec ? "box-shadow:0 0 0 3px rgba(42,157,63,.15);" : "") +
          "\">" +
          (isRec
            ? '<span class="result-option-rec" style="position:absolute;top:-11px;right:14px;background:#38b6ff;color:#fff;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;padding:3px 8px;border-radius:20px;">\u2713 Recommended</span>'
            : "") +
          '<span class="result-option-badge" style="display:inline-block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;color:' +
          (isRec ? "#38b6ff" : "#888") +
          ';">' +
          o.badge +
          "</span>" +
          '<span class="result-option-qty" style="font-size:17px;font-weight:700;color:#222;">' +
          o.qty +
          "</span>" +
           
          "</button>"
        );
      })
      .join("");

    var includesHtml = offer.includes
      .map(function (t) {
        return (
          '<li class="result-include-item" style="display:flex;align-items:flex-start;gap:8px;padding:5px 0;font-size:14px;color:#333;list-style:none;"><span class="result-include-check" style="color:#38b6ff;font-weight:700;flex-shrink:0;">\u2713</span><span>' +
          t +
          "</span></li>"
        );
      })
      .join("");

    var stage = el("quiz-stage");
    if (stage) {
      stage.innerHTML =
        '<div class="quiz-result"><p class="quiz-eyebrow">Your Result</p><h2 class="result-headline" style="font-size:24px;font-weight:800;margin:4px 0 8px;">' +
        offer.headline +
        '</h2><p class="result-subheadline" style="color:#555;margin:0 0 20px;line-height:1.5;">' +
        offer.subheadline +
        '</p><div class="result-options">' +
        optionsHtml +
        '</div><div class="result-includes" style="border-radius:12px;padding:16px 18px;margin:8px 0 20px;"><p class="result-includes-title" style="font-weight:700;margin:0 0 10px;">Kit includes:</p><ul class="result-includes-list" style="margin:0;padding:0;">' +
        includesHtml +
        '</ul></div><div class="quiz-btn-wrap"><a class="quiz-btn result-cta" id="result-cta-btn" href="#" style="text-decoration:none;text-align:center;">' +
        offer.cta +
        ' <span class="quiz-btn-arrow">\u2192</span></a></div><div class="quiz-btn-wrap" style="margin-top:8px"><button class="quiz-btn-text" id="result-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Retake quiz</button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        offer.trustLine +
        "</span></div></div>";

      var selectedVariant = offer.options[recIndex]
        ? offer.options[recIndex].variantId || ""
        : "";

      function buildUrl(variantId) {
        var url = CONFIG.productUrl;
        if (variantId && variantId.indexOf("REPLACE_") !== 0) {
          url += "?variant=" + variantId;
        }
        return url;
      }

      var ctaBtn = el("result-cta-btn");
      ctaBtn && ctaBtn.setAttribute("href", buildUrl(selectedVariant));

      stage.querySelectorAll(".result-option").forEach(function (btn) {
        btn.addEventListener("click", function () {
          selectedVariant = btn.getAttribute("data-variant");
          stage.querySelectorAll(".result-option").forEach(function (b) {
            var on = b === btn;
            b.classList.toggle("selected", on);
            b.setAttribute("aria-pressed", on);
            b.style.borderColor = on ? "#38b6ff" : "#e2e2e2";
            b.style.boxShadow = on ? "0 0 0 3px rgba(42,157,63,.15)" : "none";
          });
          ctaBtn && ctaBtn.setAttribute("href", buildUrl(selectedVariant));
        });
      });

      // apply the selected outline to the pre-selected (featured) option
      stage.querySelectorAll(".result-option.selected").forEach(function (b) {
        b.style.borderColor = "#38b6ff";
        b.style.boxShadow = "0 0 0 3px rgba(42,157,63,.15)";
      });

      var rt = el("result-retake-btn");
      rt &&
        rt.addEventListener("click", function () {
          ((state.screen = "intro"),
            (state.currentStep = 0),
            (state.answers = {}),
            renderIntro());
        });
    }
  }
 function advance() {
    var step = CONFIG.steps[state.currentStep];
    (step.infoOnly || state.answers[step.id]) &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 minute</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();